// 交收
export default {
  // 选货查询
  param_getSelection: {
    url: '/intraday-trade-query-mongo/spreadOrSelection/getSelection',
    param: {
      page: '0',
      size: '10'
      // "sort": [{
      //     "direction": "DESC",
      //     "property": "openTime"
      // }]
    }
  },
  // 铺货单
  param_getSpread: {
    url: '/intraday-trade-query-mongo/spreadOrSelection/getSpread',
    param: {
      page: '0',
      size: '10'
      // "sort": [{
      //     "direction": "DESC",
      //     "property": "openTime"
      // }]
    }
  },
  // 铺货查询
  param_getSpreadQuery: {
    url: '/intraday-trade-query-mongo/tradeQuery/querySettlementDelivery',
    param: {
      page: '1',
      size: '10'
      // 'sort':'createTime,desc'
    }
  },
  // 配对查询
  param_getPair: {
    url: '/intraday-trade-query-mongo/tradeQuery/querySettlementDelivery',
    param: {
      page: '1',
      size: '10'
      // 'sort':'createTime,desc'
    }
  },
  // 铺货批量撤销操作
  param_deleteBatchSpreadGoods: {
    url: '/intraday-delivery/manage/user/deleteBatchSpreadGoods',
    // 'url': '/intraday-trade/trade/deleteBatchSpreadGoods',
    param: {
      spreadGoodsIds: [] // 铺货表主键
    }
  },
  // 选货操作
  param_selectionGoods: {
    // 'url': '/intraday-trade/trade/selectionGoods',
    url: '/intraday-delivery/manage/user/selectionGoods',
    param: {
      commodityId: null, // 商品id
      quantity: null, // 数量
      spreadGoodsId: null // 铺货表主键（选货时传）
      // 'storageId': null, // 仓库编号（铺货时传）
      // 'warehouseId': null // 仓单编号（铺货时传）
    }
  },
  // 铺货操作
  param_spreadGoods: {
    url: '/intraday-delivery/manage/settlementUser/applySettlementDelivery',
    // url: '/intraday-trade/trade/spreadGoods',
    param: {
      commodityId: 0, //商品id
      quantity: 0, //数量
      // "spreadGoodsId": 0,//铺货表主键(选货时传)
      // storageId: 1, //仓库编号（铺货时传）
      // warehouseId: 0 //仓单编号（铺货时传）
    }
  },
  // 铺货撤销操作
  param_deleteSpreadGoods: {
    url: '/intraday-delivery/manage/user/deleteSpreadGoods',
    // 'url': '/intraday-trade/trade/deleteSpreadGoods',
    param: {
      spreadGoodsId: null // 铺货表主键
    }
  },

  // 持仓汇总
  param_queryUserPositionSummaries: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryHoldNewFront',
    data: {
      page: '1',
      size: '20'
      // 'commodityId': '',
      // 'firmId': firmId
      // "sort": [{
      //     "direction": "DESC",
      //     "property": "createTime"
      // }]
    }
  }
}
